// src/components/OrgPreview/UnitNode.js
import React, { memo } from 'react';
import { Handle, Position } from 'reactflow';
import { IconUsers } from '@tabler/icons-react';

/**
 * Custom ReactFlow node for displaying organizational units
 * Supports both vertical (TB) and horizontal (LR) layouts via dynamic handle positions
 */
const UnitNode = memo(({ data, sourcePosition, targetPosition }) => {
    const { label, userCount, isSpecial } = data;

    // Determine handle positions from props (set by Dagre layout) or use defaults
    const sourcePos = sourcePosition || Position.Bottom;
    const targetPos = targetPosition || Position.Top;

    return (
        <div className={`org-unit-node ${isSpecial ? 'special' : ''}`}>
            {/* Target handle - for potential parent connections */}
            <Handle
                type="target"
                position={targetPos}
                className="org-handle"
            />

            <div className="unit-node-content">
                <div className="unit-icon">
                    <IconUsers size={20} stroke={1.5} />
                </div>
                <div className="unit-info">
                    <span className="unit-name">{label}</span>
                    <span className="unit-count">
                        {userCount} {userCount === 1 ? 'Mitarbeiter' : 'Mitarbeiter'}
                    </span>
                </div>
            </div>

            {/* Source handle - where edges go out (to users) */}
            <Handle
                type="source"
                position={sourcePos}
                className="org-handle"
            />
        </div>
    );
});

UnitNode.displayName = 'UnitNode';

export default UnitNode;
